import { CoreButton, CoreModalDialogFooter } from '@components'
import { useOnboardingAction } from '@onboarding/hooks'
import { resetEmailVerification } from 'mmfintech-backend-api'
import { GlobalContext, tr } from 'mmfintech-commons'
import { useContext, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { WelcomeContent2 } from './WelcomeContent2'

import './welcomeModal.scss'

export const WelcomeModal = () => {
  const { modalHide } = useContext(GlobalContext)

  const dispatch = useDispatch()

  const { startOrContinueOnboarding } = useOnboardingAction()

  const onResetEmailVerification = () => {
    dispatch(resetEmailVerification())
  }

  useEffect(() => {
    return () => {
      onResetEmailVerification()
    }
  }, [])

  return (
    <div className='welcome-wrapper'>
      <div className='welcome-container' data-test='welcome-modal'>
        <WelcomeContent2 />

        <CoreModalDialogFooter>
          <div className='footer-buttons'>
            <CoreButton
              text={tr('FRONTEND.WELCOME.MODAL.START_ONBOARDING', 'Start Onboarding')}
              onClick={startOrContinueOnboarding}
              size='large'
              fullWidth
              variation='primary-black'
            />
            <CoreButton
              variation='tertiary'
              text={tr('FRONTEND.WELCOME.MODAL.DISMISS', 'Dismiss')}
              onClick={modalHide}
              size='large'
            />
          </div>
        </CoreModalDialogFooter>
      </div>
    </div>
  )
}
